"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetadataFieldName = exports.getInputValueForFormAndPrefix = exports.getS3UploadedFieldName = exports.getPlaceholderFieldName = exports.findInput = exports.getInputNameWithPrefix = exports.formatBytes = void 0;
var formatBytes = function (bytes, decimals) {
    if (bytes === 0) {
        return "0 Bytes";
    }
    var k = 1024;
    var dm = decimals <= 0 ? 0 : decimals || 2;
    var sizes = ["Bytes", "KB", "MB", "GB"];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    var n = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    var size = sizes[i];
    return "".concat(n, " ").concat(size);
};
exports.formatBytes = formatBytes;
var getInputNameWithPrefix = function (fieldName, prefix) { return (prefix ? "".concat(prefix, "-").concat(fieldName) : fieldName); };
exports.getInputNameWithPrefix = getInputNameWithPrefix;
var getInputNameWithoutPrefix = function (fieldName, prefix) { return (prefix ? fieldName.slice(prefix.length + 1) : fieldName); };
var findInput = function (form, fieldName, prefix) {
    var inputNameWithPrefix = (0, exports.getInputNameWithPrefix)(fieldName, prefix);
    var input = form.querySelector("[name=\"".concat(inputNameWithPrefix, "\"]"));
    if (!input) {
        return null;
    }
    return input;
};
exports.findInput = findInput;
var getPlaceholderFieldName = function (fieldName, prefix) { return "".concat(getInputNameWithoutPrefix(fieldName, prefix), "-placeholder"); };
exports.getPlaceholderFieldName = getPlaceholderFieldName;
var getS3UploadedFieldName = function (fieldName, prefix) { return "".concat(getInputNameWithoutPrefix(fieldName, prefix), "-s3direct"); };
exports.getS3UploadedFieldName = getS3UploadedFieldName;
var getInputValueForFormAndPrefix = function (form, fieldName, prefix) { var _a; return (_a = (0, exports.findInput)(form, fieldName, prefix)) === null || _a === void 0 ? void 0 : _a.value; };
exports.getInputValueForFormAndPrefix = getInputValueForFormAndPrefix;
var getMetadataFieldName = function (fieldName, prefix) { return "".concat(getInputNameWithoutPrefix(fieldName, prefix), "-metadata"); };
exports.getMetadataFieldName = getMetadataFieldName;
